import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/user';
import { LocaleService } from 'src/app/services/locale.service';
import { ApplicationLocale } from 'src/app/models/locale';

@Component({
  selector: 'mobile-menu-site',
  templateUrl: './mobile-menu-site.component.html',
  styleUrls: ['./mobile-menu-site.component.scss', '../mobile-menu/mobile-menu.component.scss']
})
export class MobileMenuSiteComponent implements OnInit, OnDestroy {
  @Input() data: User;
  @Input() contrast = false;

  @Output() toggleMenu = new EventEmitter<void>();

  active = false;
  links = environment.links;
  locale = ApplicationLocale.EN;

  routerSubscription: Subscription;

  constructor(
    private localeService: LocaleService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setActive(false);
      }
    });
    this.locale = this.localeService.currentLocale;
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  setActive(val: boolean = null) {
    if (val === null) {
      val = !this.active;
    }
    this.active = val;

    if (this.active) {
      this.toggleMenu.emit();
      this.document.body.classList.add('noscroll');
    } else {
      this.document.body.classList.remove('noscroll');
    }
  }
}
